module.exports = __webpack_public_path__ + "img/100-1.73fdc138.svg";